import { createSlice, PayloadAction } from "@reduxjs/toolkit";


let userDetail=null;
 const userSlice = createSlice({
  name: "userObject",
  initialState: userDetail,
  reducers: {
    setUserDetail: (
      _,
      action: PayloadAction<any>
    ) => {
     return action.payload;
    },


  },
});


export default userSlice.reducer;
export const { setUserDetail} = userSlice.actions;